__turbopack_context__.v({
  "className": "rubik_9f61a4d6-module__P3LekG__className",
  "variable": "rubik_9f61a4d6-module__P3LekG__variable",
});
